import { api } from "../client";

export async function adminSignIn({ email, password }) {
  const payload = {
    usr: email,
    pwd: password,
    email,
    password,
    portal: "admin",
  };
  const res = await api.post("/api/method/dynesourcerapi.author.login", payload);
  return {
    data: res.data,
    headers: res.headers,
  };
}
